// @flow
import { TOUR_INTRODUCTION } from 'Client/cms/toolkit/constants';
import { TourIntroductionLine } from 'Components/lines/tour-introduction-line/TourIntroductionLine';
import { tourIntroductionResolver } from './tourIntroduction.resolver';

export const tourIntroductionDescriptor = {
  name: TOUR_INTRODUCTION,
  component: TourIntroductionLine,
  resolve: tourIntroductionResolver.resolve,
};
